import styles from "./cell-addition.module.css";

import { EditOutlined, PlusOutlined } from "@ant-design/icons";

const CellAddition = ({ hours, ...props }) => {
  return (
    <div className={styles.btn} {...props}>
      {hours ? <EditOutlined /> : <PlusOutlined />}
    </div>
  );
};

export default CellAddition;
